import {Frequency} from '@hconnect/common/types'

import {FrequencyDropDownConfig} from '../types'

export const TIME_STEP_BUTTON_CONFIG: FrequencyDropDownConfig[] = [
  {
    value: Frequency.Daily,
    label: 'kpiCalculationSettings.label.daily'
  },
  {
    value: Frequency.Weekly,
    label: 'kpiCalculationSettings.label.weekly'
  },
  {
    value: Frequency.Monthly,
    label: 'kpiCalculationSettings.label.monthly'
  },
  {
    value: Frequency.Yearly,
    label: 'kpiCalculationSettings.label.yearly'
  }
]

export const FIELD_WIDTH = {xs: '100%', md: '60%'}
